import { Controller } from "@hotwired/stimulus"

/**
 * Churn Survey Controller
 *
 * Progressive enhancement only — the survey is fully usable without it:
 * conditional questions are rendered server-side already expanded when the
 * pre-filled reason matches, and the sanitizer drops out-of-context answers
 * and over-long multi-selects anyway.
 *
 * - reveals/hides questions that depend on another answer (data-depends-on)
 * - keeps multi-selects within their data-max-selected budget
 */
export default class extends Controller {
  static targets = ["conditional", "group"]

  connect() {
    this.refresh()
  }

  refresh() {
    for (const element of this.conditionalTargets) {
      const dependsOn = element.dataset.dependsOn
      const allowed = (element.dataset.dependsValues || "").split(" ").filter(Boolean)
      const selected = this.element.querySelector(`input[name="report[survey][${dependsOn}]"]:checked`)
      element.classList.toggle("d-none", !(selected && allowed.includes(selected.value)))
    }
  }

  limitSelection(event) {
    const group = event.target.closest("[data-max-selected]")
    if (!group) return

    const max = Number.parseInt(group.dataset.maxSelected, 10)
    if (!Number.isFinite(max) || max <= 0) return

    const checked = group.querySelectorAll("input[type=checkbox]:checked")
    if (checked.length > max) event.target.checked = false
  }
}
